module.exports = __webpack_public_path__ + "static/media/B_E02.fa254faa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_E02.png
// module id = 113
// module chunks = 0